var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("article", [
    _c("p", { staticClass: "title" }, [_vm._v("Engine")]),
    _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label" }, [_vm._v("VIN")]),
      _c(
        "p",
        { staticClass: "control" },
        [
          _c("the-mask", {
            directives: [
              {
                name: "fq-validate",
                rawName: "v-fq-validate",
                value: _vm.$v.entity.vin,
                expression: "$v.entity.vin",
              },
            ],
            staticClass: "input is-uppercase",
            attrs: { name: "vin", mask: _vm.vinMask, tokens: _vm.vinTokens },
            model: {
              value: _vm.entity.vin,
              callback: function ($$v) {
                _vm.$set(_vm.entity, "vin", $$v)
              },
              expression: "entity.vin",
            },
          }),
        ],
        1
      ),
      !_vm.$v.entity.vin.customMinLength
        ? _c("span", { staticClass: "help is-danger" }, [
            _vm._v("Vin should have at least 7 characters"),
          ])
        : _vm._e(),
      !_vm.$v.entity.vin.maxLength
        ? _c("span", { staticClass: "help is-danger" }, [
            _vm._v("Vin max 17 characters"),
          ])
        : _vm._e(),
    ]),
    _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Engine no")]),
      _c("p", { staticClass: "control" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.entity.engineNo,
              expression: "entity.engineNo",
            },
          ],
          staticClass: "input",
          attrs: { type: "text", placeholder: "ABCD1234" },
          domProps: { value: _vm.entity.engineNo },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.entity, "engineNo", $event.target.value)
            },
          },
        }),
      ]),
    ]),
    _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label" }, [_vm._v("No. of cylinders")]),
      _c(
        "p",
        { staticClass: "control" },
        [
          _c("the-mask", {
            staticClass: "input",
            attrs: { placeholder: "e.g. 6", mask: ["###"] },
            model: {
              value: _vm.entity.cylinders,
              callback: function ($$v) {
                _vm.$set(_vm.entity, "cylinders", $$v)
              },
              expression: "entity.cylinders",
            },
          }),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Engine size")]),
      _c(
        "p",
        { staticClass: "control" },
        [
          _c("the-mask", {
            staticClass: "input",
            attrs: {
              placeholder: "e.g. 1300",
              mask: _vm.engineSizeMask,
              tokens: _vm.engineSizeTokens,
            },
            model: {
              value: _vm.entity.engineSize,
              callback: function ($$v) {
                _vm.$set(_vm.entity, "engineSize", $$v)
              },
              expression: "entity.engineSize",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }